import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "supplierSelect", "preferredToggle", "quoteStatusSelect", "selectionStatusSelect", "parent", "grandParent"];

    connect() {
        this.applyFilters();
    }

    applyFilters() {
        const searchText = this.inputTarget.value.toLowerCase();
        const supplier = this.supplierSelectTarget.value;
        const preferredOnly = this.preferredToggleTarget.checked;
        const quoteStatus = this.quoteStatusSelectTarget.value;
        const selectionStatus = this.selectionStatusSelectTarget.value;

        this.parentTargets.forEach((el) => {
            const filterName = (el.getAttribute("data-filter-name") || "").toLowerCase();

            let visible = true;

            if (searchText && !filterName.includes(searchText)) visible = false;

            if (supplier) {
                if (preferredOnly) {
                    const raw = el.getAttribute("data-filter-preferred-suppliers") || "";
                    const preferredList = raw ? raw.split(",") : [];
                    if (!preferredList.includes(supplier)) visible = false;
                } else {
                    const raw = el.getAttribute("data-filter-price-suppliers") || "";
                    const priceList = raw ? raw.split(",") : [];
                    if (!priceList.includes(supplier)) visible = false;
                }
            }

            if (quoteStatus) {
                const itemQuoteStatus = el.getAttribute("data-filter-quote-status") || "";
                if (itemQuoteStatus !== quoteStatus) visible = false;
            }

            if (selectionStatus) {
                const itemSelectionStatus = el.getAttribute("data-filter-selection-status") || "";
                if (itemSelectionStatus !== selectionStatus) visible = false;
            }

            el.classList.toggle("hidden", !visible);
        });

        this.filterGrandParents();
    }

    filterGrandParents() {
        this.grandParentTargets.forEach((gp) => {
            const visibleChildren = gp.querySelectorAll('[data-estimate-filter-target="parent"]:not(.hidden)');
            gp.classList.toggle("hidden", visibleChildren.length === 0);
        });
    }
}
